// import service from '@/utils/request'
import service from "@/utils/axios-v2";

// 获取司机实时地理位置
export function getDiverRealtimeGps(data) {
  data = data ? data : {};
  let url = '/zuul/user/latest/gps/info';
  if (data.driverId) {
    url += '?' + data.driverId.map(x => `driverId=${x}`).join('&')
    delete data.driverId
  }
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url,
    method: 'get',
    params: Object.assign({}, {page: 1, size: 10000 }, data),
    headers: {
      'portal-token': true
    }
  }).then(res => res.data);
}
